export const TRY_NOW = {
    image: "https://newsoft-ns.com/media/trynow_case/CEO_says.webp",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“TryNow is a valued and significant client of Newsoft, with whom we have had a successful 3-year partnership.",
        "Our engineers with relevant expertise played a pivotal role in the project's development from the start. The Ukrainian team made a significant contribution, not only in the technical aspect but also in various other areas, including project management, quality assurance, creative problem-solving and effective communication.",
        "Through this project, we have created valuable outcomes for both the client and Newsoft. TryNow provided us with stability in the early stages of our establishment, and extensive opportunities to grow and build teams. We are sure that this collaboration was a Win-Win and we were delighted to have been a part of this exciting project.”",
    ],
}

export const ORBIT = {
    image: "https://newsoft-ns.com/media/trynow_case/CEO_says.webp",
    imageAlt: "Volodymyr Tkach - CEO & Co-Founder at Newsoft",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“We collaborated with Jacob, co-owner of the stunning Orbit project, leveraging our longstanding relationship. Entrusted with the complete development process, including frontend, backend, design, and testing, we exceeded expectations with a dedicated team of four.",
        "Our exceptional synergy and performance surpassed project requirements, impressing Jacob. Throughout development, he appreciated our proactive approach, organization, top-notch quality, and efficient work pace. We effectively addressed process improvement requests, documenting tasks and conducting thorough testing.”",
    ],
}

export const GAMETECH = {
    image: "https://newsoft-ns.com/media/home/Call_to_action.webp",
    imageAlt: "Volodymyr Tkach - CEO & Co-Founder at Newsoft",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“Gametech was our biggest betting project that allowed us to utilize our prior experience and extensive knowledge in the industry.",
        "We effectively transformed business objectives into technical solutions and delivered mobile applications that fully met the client's needs. Thanks to our proactivity, strength and productivity, we got the company's shares.",
        "The primary objective of the client is to enter Nasdaq, and we are actively working in collaboration with them to identify technical improvements required to achieve this goal. We are thrilled to have partnered with Gametech and CEO Jameson, a highly influential and reputable businessman from the UK.”",
    ],
}

export const QUARKWORKS = {
    image: "https://newsoft-ns.com/media/home/Call_to_action.webp",
    imageAlt: "Volodymyr Tkach - CEO & Co-Founder at Newsoft",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“Quarkworks is one of our major clients and has been operating in the market for over a decade.",
        "Our partnership with Quarkworks lasted for three years, during which we successfully completed four different projects. These projects were technologically and industrially diverse. We were able to swiftly identify and assign the necessary experts, which had been a challenging task for the client in the US. The primary projects of Quarkworks were completed in collaboration with Newsoft, resulting in the achievement of their predetermined objectives.",
        "As Quarkworks transitioned from a service company to a product company, we continued to work together with them. Our commitment to delivering high-quality work and the client’s trust resulted in a successful partnership and a Win-Win outcome.”",
    ],
}

export const HELLO = {
    image: "https://newsoft-ns.com/media/home/Call_to_action.webp",
    imageAlt: "Volodymyr Tkach - CEO & Co-Founder at Newsoft",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“We were thrilled to participate in a project of such ambition that was being developed within Google. The social network we worked on had rich functionality and a unique architectural approach, providing us with valuable experience.",
        "This project was undoubtedly significant for us, and it allowed us to learn how to effectively develop projects of similar calibre.”",
    ],
}

export const CRAFT = {
    image: "https://newsoft-ns.com/media/home/Call_to_action.webp",
    imageAlt: "Volodymyr Tkach - CEO & Co-Founder at Newsoft",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“Craft is a major investment company that engaged our services to develop a project aimed at analyzing their portfolio companies.",
        "Our Python developer, who had a strong mathematical background, played a pivotal role in the project, contributing significantly to the development process. His expertise in mathematics and statistics added significant value to the project, which would have been difficult to achieve without his skillset.",
        "As a result, we were able to provide unique expertise and successfully develop the project, which led to the expansion of the entire team.”",
    ],
}

export const PEDNET = {
    image: "https://newsoft-ns.com/media/home/Call_to_action.webp",
    imageAlt: "Volodymyr Tkach - CEO & Co-Founder at Newsoft",
    name: "Volodymyr Tkach",
    desc: "CEO & Co-Founder at Newsoft",
    linkedin: "https://www.linkedin.com/in/vova-tkach/",
    text: [
        "“PedNet was our first Flutter project, which allowed our Android developer to become familiar with Flutter and achieve his objectives.",
        "We built the project from scratch, enabling users to interact with local authorities in Columbia, Missouri, and report issues related to road safety, pedestrians, and cyclists. By effectively translating the customer’s business objectives into technical solutions, we gained significant experience in both developing the Flutter project from scratch and establishing this department within our company.",
        "As a result of this experience, we saw a rise in the number of new partnerships.”",
    ],
}
